<template>
	<div>
		<v-list-item-group v-model="$selected">
			<v-list-item v-for="item in items" :key="item.guid" :value="item">
				<v-list-item-content>
					<v-list-item-title>{{ item.name }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list-item-group>
	</div>
</template>

<script>
export default {
	props: {
		items: { type: Object, required: true, default: () => ({}) },
		selected: { type: Object, required: false, default: null },
	},

	data: () => ({}),

	computed: {
		$selected: {
			get() {
				return this.selected;
			},
			set(value) {
				this.$emit("update:selected", value);
			},
		},
	},
};
</script>
